<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix">
      <!--左侧导航 start-->
      <user-nav :userNav="userNav"></user-nav>
      <!--左侧导航 end-->
      <!--右侧内容 start-->
      <div class="video-play user-main-right">
        <div class="user-order-title">
          <span class="user-order-title-mine">我的线上课</span>
          <span class="user-order-title-sign-in" @click="classSign()"
            >签到</span
          >
        </div>
        <h2 class="title">{{ titleName }}</h2>
        <div class="video-box">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            @play="onPlay($event)"
            @pause="onPlayerPause($event)"
            @ended="onPlayerEnded($event)"
            @timeupdate="onPlayerTimeupdate($event)"
            @statechanged="playerStateChanged($event)"
         
          ></video-player>
        </div>
        <div class="play-nav">
          <a
            href="javascript:;"
            :class="{ active: tabShow == 1 }"
            @click="tabShowFun(1)"
            >课节</a
          >
          <a
            href="javascript:;"
            :class="{ active: tabShow == 2 }"
            @click="tabShowFun(2)"
            >课程讲义</a
          >
          <a
            href="javascript:;"
            :class="{ active: tabShow == 3 }"
            @click="tabShowFun(3)"
            >教师详情</a
          >
        </div>
        <div class="tab-box">
          <div class="video-detail-list" v-if="tabShow == 1">
            <p
              class="video-detail-list-item"
              v-for="(item, index) of lessons_list"
              :key="index"
              @click="changeVideo(index, item.id)"
            >
              <span>{{ item.lessons_name }}</span>
              <span style="color: #b5b5b5">
                时长
                {{
                  Math.floor(item.video_time / 60) +
                  ":" +
                  ((item.video_time % 60) / 100).toFixed(2).slice(-2)
                }}分钟 {{ item.have_learn_num }}人学过 已学{{
                  
                  (item.have_learn_time>item.video_time ? 100 :   Math.floor((item.have_learn_time / item.video_time) * 100))
                
                }}%
              </span>
            </p>
          </div>
          <div class="video-detail-list" v-if="tabShow == 2">
            <h2 class="syllabus-title">
              <i
                ><img
                  src="../../../static/images/syy-images/video-studay-icon.png"
                  width="12" /></i
              >课程讲义
            </h2>
            <p class="syllabus-inner" v-html="play_video.lessons_handout">
              {{ play_video.lessons_handout }}
            </p>
          </div>
          <div class="video-detail-list" v-if="tabShow == 3">
            <div class="video-teacher-img">
              <img :src="teacher_info.teacher_pic" width="100%" />
            </div>
            <p class="video-teacher-name">{{ teacher_info.teacher_name }}</p>
            <div class="video-teacher-info">
              <p class="video-teacher-info-item">
                <i
                  ><img
                    src="../../../static/images/syy-images/teacher-school-icon.jpg"
                    width="18" /></i
                ><span class="green">毕业学校</span
                ><span>{{ teacher_info.school }}</span>
              </p>
              <p class="video-teacher-info-item">
                <i
                  ><img
                    src="../../../static/images/syy-images/experience-icon.jpg"
                    width="18" /></i
                ><span class="green">教学经验</span
                ><span>{{ teacher_info.experience }}</span>
              </p>
              <p class="video-teacher-info-item">
                <i
                  ><img
                    src="../../../static/images/syy-images/characteristic-icon.jpg"
                    width="14" /></i
                ><span class="green">教学特点</span
                ><span>{{ teacher_info.peculiarity }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
import UserNav from ".././components/user-nav.vue";
import navCom from "../../components/welcome-nav";
import footerCom from "../../components/foot";
import axios from "axios";
import tool from "../../assets/js/tool";

export default {
  name: "record-video-play",
  data() {
    return {
      navActive: 3,
      userNav: 4,
      tabShow: 1,
      course_id: this.$route.query.course_id, //课程ID
      teacher_id: this.$route.query.teacher_id, //教师ID
      video: {}, //视频
      course: {
        lessons: [],
      }, //课程详情
      play_video: Object, //视频接口
      teacher_info: Object, //教师信息
      lessons_list: Array, //课节列表
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "", //url地址
          },
        ],
        // poster: "../../../static/images/syy-images/zs.png", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      titleName: "",
      sec: "", //学习时长
      video_time: "", //视频时长
      user_id: "",
      lessons_id: "",
      timeFlag: false,
    };
  },
  components: {
    UserNav,
    navCom,
    footerCom,
  },
   beforeRouteLeave(to,form,next){
    this.onPlayerPause();
    setTimeout(() => {
      next()
    }, 1000);
  },
  methods: {

    /* 获取视频播放进度 */
    onPlayerTimeupdate(player) {
      this.timeFlag = true;
      this.sec = player.cache_.currentTime;
    },
    onPlay(e) {
      console.log(e, "开始");
      e.currentTime(this.sec);
    },
    onPlayerEnded(e) {
      console.log(e, "结束",this.course_id);
         if (this.sec) {
          var params = {
            user_id: this.user_id,
            course_id: this.course_id,
            lessons_id: this.lessons_id,
            sec: Math.ceil(this.sec),
          };
          tool.postData("Center_My_Course/create_time", params, (res) => {
            if (res.data.code == 200) {
              this.sec = "";
            }
          });
        }
    },
    onPlayerPause(e) {
      console.log(e, "暂停事件",this.course_id);
         if (this.sec) {
          var params = {
            user_id: this.user_id,
            course_id: this.course_id,
            lessons_id: this.lessons_id,
            sec: Math.ceil(this.sec),
          };
          tool.postData("Center_My_Course/create_time", params, (res) => {
            if (res.data.code == 200) {
              this.sec = "";
            }
          });
        }
    },
    //播放状态改变回调
    playerStateChanged(playerCurrentState) {
      console.log("player current update state", playerCurrentState);
    },
    tabShowFun(num) {
      this.tabShow = num;
    },
    /** 获取视频*/
    getVideo(index) {
      let data = {
        user_id: this.$store.state.uuid,
        lessons_id: this.$route.query.id, //课节ID
      };
      tool.postData("Center_My_Course/play_video", data, (res) => {
        this.play_video = res.data.data;
        this.teacher_info = res.data.data.teacher_info;
        this.lessons_list = res.data.data.lessons_list;
      });
    },

    /* 切换视频*/
    changeVideo(index, id) {
      var data;
      // 判断是不是第一次触发这个时间
      if (id) {
        // this.timeFlag
        // old id和new id 可以拿到  判断是否触发播放  根据sec有没有值判断  如果有 证明还没播放
        if (this.sec) {
          var params = {
            user_id: this.user_id,
            course_id: this.course_id,
            lessons_id: this.lessons_id,
            sec: Math.ceil(this.sec),
          };
          tool.postData("Center_My_Course/create_time", params, (res) => {
            if (res.data.code == 200) {
              this.sec = "";
            }
          });
        }
        // 新的课节id赋值
        this.lessons_id = id;
        data = {
          user_id: this.$store.state.uuid,
          lessons_id: id, //课节ID
        };
      } else {
        data = {
          user_id: this.$store.state.uuid,
          lessons_id: this.$route.query.id, //课节ID
        };
      }

      tool.postData("Center_My_Course/play_video", data, (res) => {
        console.log(res,"res")
        this.titleName = res.data.data.lessons_list[index].lessons_name;
        this.playerOptions.sources[0].src =
          // "http://dianbo-sigutest.siguedu.zihai.cn/" +
          res.data.data.lessons_video;
        this.lessons_list = res.data.data.lessons_list;
        console.log(this.playerOptions.sources[0].src)
      });
    },
    //课节签到
    classSign() {
      var that = this;
      let data = {
        user_id: this.user_id,
        lesson_id: this.$route.query.id, //课节ID
      };
      axios.post("/api/Center_User/signUp", data).then(function (res) {
        /** 成功 : 1 **/
        if (res.data.code == 200) {
          that.$toast.center(res.data.msg);
        } else {
          /** 失败 : 0/3 **/
          /** 提示错误信息 : 0  **/
          if (res.data.code == 400) {
            that.$toast.center(res.data.msg);
          }
        }
      });
    },
  },
  mounted() {
    this.user_id = this.$store.state.uuid;
    this.lessons_id = this.$route.query.id;
    this.course_id = this.$route.query.course_id;
    console.log(this.$route.query.lessons_id)
    this.getVideo();
    this.changeVideo(this.$route.query.index);
     window.removeEventListener('unload', e => this.onPlayerPause(e))
  },
};
</script>

<style scoped>
.w {
  width: 1200px;
  margin: 0 auto;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.all-whole {
  background: #fbfbfb;
  height: 100%;
}

.user-main-right {
  width: 1000px;
  float: right;
  min-height: 1286px;
  background: #ffffff;
}

.user-order-title {
  width: 100%;
  height: 70px;
  line-height: 100px;
  box-sizing: border-box;
  border-bottom: 1px solid #e3e3e3;
  font-size: 18px;
  color: #252525;
  padding: 0 20px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
}

.video-play .title {
  text-align: center;
  font-size: 20px;
  color: #2b2b2b;
  line-height: 88px;
  font-weight: normal;
}

.video-box {
  width: 862px;
  height: 487px;
  margin: 0 auto;
}

.play-nav {
  width: 926px;
  height: 40px;
  margin: 33px auto 0;
  border-bottom: 1px solid #e3e3e3;
}

.play-nav a {
  margin-right: 56px;
  font-size: 18px;
  color: #646464;
  line-height: 40px;
  padding-bottom: 7px;
}

.play-nav a.active {
  color: #1a71ff;
  border-bottom: 3px solid #1a71ff;
}

.video-detail-list {
  margin-top: 15px;
  padding-bottom: 183px;
}

.tab-box {
  width: 926px;
  margin: 0 auto;
}

.video-detail-list-item {
  border-bottom: 1px solid #e3e3e3;
  line-height: 45px;
  cursor: pointer;
}

.video-detail-list-item span:first-child {
  color: #1a71ff;
  font-size: 16px;
}

.video-detail-list-item span:last-child {
  color: #1a71ff;
  font-size: 14px;
  margin-left: 20px;
}

.syllabus-title {
  font-size: 16px;
  color: #1a71ff;
  font-weight: 500;
  margin-top: 25px;
}

.syllabus-title i {
  display: inline-block;
  margin-right: 12px;
  vertical-align: middle;
  position: relative;
}

.syllabus-inner {
  color: #898989;
  font-size: 14px;
  line-height: 26px;
  margin-top: 13px;
}

.video-teacher-img {
  width: 108px;
  height: 108px;
  margin: 27px auto 0;
  overflow: hidden;
  border-radius: 50%;
}

.video-teacher-name {
  text-align: center;
  color: #5d5d5d;
  font-size: 20px;
  line-height: 50px;
  margin-bottom: 20px;
}

.video-teacher-info-item {
  margin-bottom: 24px;
}

.video-teacher-info-item i {
  margin-right: 11px;
  position: relative;
}

.video-teacher-info-item span {
  margin-right: 11px;
  font-size: 16px;
  color: #7c7c7c;
  line-height: 30px;
}

.video-teacher-info-item .green {
  color: #1a71ff;
  margin-right: 11px;
}
.user-order-title-mine {
  font-weight: bolder;
}
.user-order-title-sign-in {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/record-video-play.vue